import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Breadcrumb from "@/components/feature/Breadcrumb";
import TrustBannerSection from "@/components/feature/TrustBannerSection";

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="Aviso Legal | Persianas Málaga"
        description="Aviso legal de Persianas Málaga. Servicio técnico especialista en reparación de persianas, mosquiteras y motorización en Málaga capital."
        noindex
      />
      <Navbar />
      <Breadcrumb items={[
        { label: "Inicio", path: "/" },
        { label: "Aviso Legal" },
      ]} />
      <main className="pb-20 md:pb-0">
        <section className="py-14 md:py-20">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-8 font-heading">Aviso Legal</h1>
            <div className="prose prose-sm max-w-none text-foreground-700 space-y-6">
              <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSICE), se exponen a continuación los datos identificativos de la entidad titular de este sitio web:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Titular:</strong> Persianas Málaga</li>
                <li><strong>Dirección:</strong> Málaga, Andalucía, España</li>
                <li><strong>Teléfono:</strong> 951 12 07 70</li>
                <li><strong>Email:</strong> info@persianas-malaga.es</li>
              </ul>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Condiciones de uso</h2>
              <p>El acceso y uso de este sitio web implica la aceptación plena y sin reservas de las presentes condiciones de uso. El usuario se compromete a utilizar el sitio web y sus contenidos de conformidad con la ley, el presente aviso legal y las buenas costumbres.</p>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Propiedad intelectual</h2>
              <p>Todos los contenidos del sitio web (textos, imágenes, logotipos, estructura, diseño) son propiedad del titular o de terceros que han autorizado su uso, y están protegidos por la legislación de propiedad intelectual.</p>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Exclusión de responsabilidad</h2>
              <p>El titular no se hace responsable de los daños y perjuicios que pudieran derivarse del uso de la información contenida en el sitio web, ni de los errores u omisiones que pudieran existir.</p>
            </div>
          </div>
        </section>
      </main>
      <TrustBannerSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}